import { cUtil } from "../../functions/util";

export class cFooter {

  constructor() {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const elm        = document.querySelector('.c-language-switcher') as HTMLAnchorElement;
    const locale     = cUtil.locale();
    const destLocale = locale === 'fr' ? '' : '/fr';

    const path =
      window.location.pathname.startsWith('/de/') || 
      window.location.pathname.startsWith('/fr/') 
      ? window.location.pathname.substring(3) : window.location.pathname

    const link = destLocale + path + window.location.search;

    const text    = destLocale === '/fr' ? __('Französisch', 'custom') : __('Deutsch', 'custom'); 
    elm.href      = link;
    elm.innerText = text;
  }

}